import storage from '../../utils/storage'
import BLOCK from '../../constants/BlockTypes/BlocksEnum'
import memoryTutorialCoverPic from './i/memory-cover-tutorial.png'
import memoryTutorialPreviewPic from './i/memory-preview-tutorial.gif'

const keyStore = 'watchedTips'

export class Tip {
    id
    coverPicture
    previewPicture
    resourceLink
    blockType

    constructor(id, coverPicture, previewPicture, resourceLink, blockType) {
        this.id = id
        this.coverPicture = coverPicture
        this.previewPicture = previewPicture
        this.resourceLink = resourceLink
        this.blockType = blockType
    }
}

const tips = [
    new Tip(
        '1',
        memoryTutorialCoverPic,
        memoryTutorialPreviewPic,
        'https://blog.interacty.me/?p=75',
        BLOCK.memoryCards,
    ),
]

export function getTips() {
    return tips
}

export function getWatchedTipsMap() {
    return storage.getValue(keyStore, Object) || {}
}

export function putWatchedTipsMap(watchedTips) {
    storage.setValue(keyStore, watchedTips)
}
